import axiosIns from '@/libs/axios'
import utilsService from './utilsService'

const controller = 'user'

export default {
  async getAll(filter) {
    // Limpa o filtro removendo valores vazios
    const cleanFilter = utilsService.cleanObject(filter)
    const response = await axiosIns.get(`${controller}?${utilsService.getQueryParams(cleanFilter)}`)
    return response.data
  },

  async getAllAlunos(filter) {
    const userId = JSON.parse(localStorage.getItem('userData') || '{}')?.id
    const cleanFilter = utilsService.cleanObject(filter)
    const response = await axiosIns.get(`${controller}/professor/${userId}/estudantes?${utilsService.getQueryParams(cleanFilter)}`)
    return response.data
  },

  async getById(id) {
    const response = await axiosIns.get(`${controller}/${id}`)
    return response.data
  },

  async getByLogin(login) {
    const response = await axiosIns.get(`${controller}?login=${login}`)
    return response.data.content[0]
  },

  async update(obj) {
    const response = await axiosIns.put(controller, obj)
    return response.data
  },

  async approveStudent(id, approved) {
    const response = await axiosIns.patch(`${controller}/${id}`, { approved })
    return response.data
  },

  async changeClassroom(id, classroomId) {
    const response = await axiosIns.patch(`${controller}/${id}/turma`, { classroomId })
    return response.data
  },

  async delete(id) {
    const response = await axiosIns.delete(`${controller}/${id}`)
    return response.data
  },

  async create(req) {
    const response = await axiosIns.post(controller, req)
    return response.data
  },

  async changePassword(req) {
    const response = await axiosIns.put(`${controller}/change-password`, req)
    return response.data
  },

  async obterUserScore(req) {
    const response = await axiosIns.put(`${controller}/change-password`, req)
    return response.data
  },

  async getProfessorTurmas(id) {
    const response = await axiosIns.get(`professor/${id}`)
    return response.data
  },

  async vincularTurma(dto) {
    const response = await axiosIns.post(`professor/vincular-turma`, dto)
    return response.data
  },

  async desvincularTurma(dto) {
    const response = await axiosIns.post(`professor/desvincular-turma`, dto)
    return response.data
  },
}
